import React, { useState, useEffect } from "react";
import firebase from "firebase";
import "../../assets/styles/custom/components/login.scss";
import "../../assets/styles/custom/components/register.scss";
import logo from "../../assets/images/Group 51.svg";
import { Tooltip } from "antd";
import "./login.scss";
import Popup1 from "./../Dashboard/Crew/popup1";
import Popup2 from "./../Dashboard/Crew/popup2";
import { useHistory } from "react-router-dom";
import { useAlert } from "react-alert";
import { withRouter } from "react-router-dom";
import Register from "../Register/Register";

const Login = () => {
  const alert = useAlert();
  let history = useHistory();
  const [userEmail, setEmail] = useState("");
  const [userPassword, setPassword] = useState("");
  const [forgotPassword, setForgotPassword] = useState(false);
  const [isRegister, SetRegister] = useState(false);
  const [popupToggle1, setpopupToggle1] = useState(false);
  const [popupToggle2, setpopupToggle2] = useState(false);
  const [Blankform, setBlankform] = useState("");
  const popup1 = (data) => {
    setpopupToggle1(!popupToggle1);
    setBlankform(data);
  };
  const popup2 = (data) => {
    setpopupToggle1(!popupToggle1);
    setBlankform(data);
  };
  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        history.push("/main-dashboard");
      }
    });
  }, []);
  const login = async (e) => {
    e.preventDefault();
    firebase
      .auth()
      .signInWithEmailAndPassword(userEmail, userPassword)
      .then((user) => {
        firebase
          .firestore()
          .collection("users")
          .doc(user.user.uid)
          .get()
          .then((userDoc) => {
            validateUser(userDoc);
          })
          .catch((error) => {
            handleError(error);
          });
      })
      .catch((error) => {
        handleError(error);
      });
  };
  function handleError(error) {

    alert.show("RVR 0 ! Access Denied !!", {

      timeout: 5000,
      type: "error",
    });
    console.log(error);
    firebase.auth().signOut();
    setPassword("");
    setEmail("");
  }
  function validateUser(userDoc) {
    if (userDoc.exists && userDoc.data().active === false) {
      firebase.auth().signOut();

      alert.show("Below minima! Access Denied !!", {
        timeout: 5000,
        type: "error",
      });

    } else {
      alert.show("Cleared for takeoff !!", {
        timeout: 3000,
        type: "success",
      });
      return history.push("/main-dashboard");
    }
  }
  const loginWithGoogle = (e) => {
    e.preventDefault();
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((user) => {
        firebase
          .firestore()
          .collection("users")
          .doc(user.user.uid)
          .get()
          .then((userDoc) => {
            validateUser(userDoc);
          })
          .catch((error) => {
            handleError(error);
          });
      })
      .catch((error) => {
        handleError(error);
      });
  };
  const passwordReset = (e) => {
    e.preventDefault();
    if (userEmail === "") {

      alert.show("Hold Short ! Enter email & click Forgot", {
        timeout: 5000,
        type: "error",
      });

      return;
    }
    firebase
      .auth()
      .sendPasswordResetEmail(userEmail)
      .then(() => {

        alert.show("METAR 0100 CAVOK Check email to reset password  !!!", {
          timeout: 5000,
          type: "success",
        });

        console.log("Email sent successfully!!");
        setForgotPassword(false);
        setEmail("");
        return null;
      })
      .catch((err) => {
        alert.show(
          "Couldn't send password reset email!!  Try later or contact support@amiagi.com",
          {
            timeout: 3000,
            type: "error",
          }
        );
        console.log("Couldn't send email!!");
        setEmail("");
        setForgotPassword(false);
        throw err;
      });
  };

  return isRegister ? (
    <Register
      closeForm={() => {
        SetRegister(false);
      }}
    />
  ) : (
    <div className="login-container">
      <div className="login-box">
        <img className="logo" src={logo} alt="" />
        <div className="login-description">
          Advanced Aviation Training Management System
        </div>
        <div className="login-title">Log In</div>
        <form>
          <input
            type="Email"
            placeholder="Email"
            value={userEmail}
            onChange={(e) => setEmail(e.target.value)}
            className="login-input"
          ></input>
          <div
            className={forgotPassword ? "hide-element" : "input-with-tooltip"}
          >
            <input
              type="password"
              placeholder="Password"
              className="login-input"
              value={userPassword}
              onChange={(e) => setPassword(e.target.value)}
            ></input>
            <Tooltip
              title="Contact to your training manager"
              className="input-tooltip"
            >
              <i className="fas fa-question-circle"></i>
            </Tooltip>
          </div>
          <div className="login__button-box">
            <button
              type="submit"
              className={
                forgotPassword ? "hide-element" : "login-submit login-submit--1"
              }
              onClick={login}
            >
              Log in
            </button>
            <button
              type="submit"
              className="login-submit login-submit--2"
              onClick={() => {
                SetRegister(true);
              }}
            >
              Register
            </button>

            <button
              type="submit"
              className={
                forgotPassword ? "hide-element" : "login-submit login-submit--3"
              }
              onClick={passwordReset}
            >
              Forgot
            </button>
            <button
              className="login-submit login__button--4"
              onClick={loginWithGoogle}
            >
              Google Signin
            </button>
          </div>
        </form>

        <span className="terms">
          By logging in, you agree with &nbsp;
          <a
            onClick={() => {
              popup1(
                "https://firebasestorage.googleapis.com/v0/b/aatmsv4-firebase.appspot.com/o/AmiAgi%20standard%20terms%20and%20conditions.pdf?alt=media&token=73ef1e0b-ebba-437f-a74d-3858774e2c7a"
              );
            }}
          >
            {popupToggle1 === true ? (
              <Popup1
                setpopupToggle1={setpopupToggle1}
                simulatorData={Blankform}
              />
            ) : null}
            AmiAgi’s Terms and Conditions.
          </a>
        </span>

        <span className="terms">
          By logging in, you agree with our &nbsp;
          <a
            className="cursor"
            onClick={() => {
              popup2(
                "https://firebasestorage.googleapis.com/v0/b/aatmsv4-firebase.appspot.com/o/pp.pdf?alt=media&token=3571d632-1e14-449e-ae37-84b4a17e5c06"
              );
            }}
          >
            {popupToggle2 === true ? (
              <Popup2
                setpopupToggle2={setpopupToggle2}
                simulatorData={Blankform}
              />
            ) : null}
            Privacy Policy.
          </a>
        </span>
        <p>
          <a href="mailto:support@amiagi.com"> Contact AmiAgi Team </a>
        </p>
      </div>
    </div>
  );
};
export default withRouter(Login);
